{
  "comment": "Mission 4, Sealed Records (spec §7; S13 owns): a data-driven step machine (plan §2; the runtime is S6). Offered at tier 4 with settlement weight ≥ 1; the giver is Ines Duarte (the Charter Hub dock, or her comms line, spec §3.1). No step has a deadline. brief: Duarte's call ends on the route; the route fork shows what each one costs. Legal: the records fee, the request logged (archive_legal: one gate-clock alert step; hale_knows; at Hale's call he traces her pulled digest: duarte_exposed). Back: the Mutual relay crew's maintenance slot (a relayParts delivery, no Authority clearance), Mutual +10; if Hale already knows of the core (hale_aware) the crew is audited at his call (src/story/hale.ts). archive: the legal route docks at authority-seat; the back route delivers the relay parts to the archive relay (the fallback). file: Settlement 50-A is taken at the archive (a story item). hale: Hale's call; the deal fork. take goes through hale.ts takeHaleDeal (the waiver or the founding fee, old bounties only and capped, the Holdfast claims; Hale keeps the original, the player keeps a copy). refuse keeps the file and the registry entry shows withdrawn. Fork costs are the text shown before commit.",
  "id": "m4",
  "offer": {
    "tier": 4,
    "threadWeight": [
      {
        "thread": "settlement",
        "min": 1
      }
    ],
    "contact": "duarte",
    "comms": "m4.duarte.offer"
  },
  "steps": [
    {
      "id": "brief",
      "verb": "comms",
      "target": { "kind": "node", "ref": "m4.duarte.route" }
    },
    {
      "id": "archive",
      "verb": "deliver",
      "target": { "kind": "station", "ref": "authority-seat" },
      "fallback": { "kind": "target", "ref": "archive-relay" }
    },
    {
      "id": "file",
      "verb": "recover",
      "target": { "kind": "item", "ref": "settlement_50a" },
      "item": "settlement_50a",
      "onDone": { "items": [{ "id": "settlement_50a", "state": "held" }], "comms": "m4.hale.call" }
    },
    {
      "id": "hale",
      "verb": "comms",
      "target": { "kind": "node", "ref": "m4.hale.offer" }
    }
  ],
  "forks": [
    {
      "id": "route",
      "afterStep": "brief",
      "choices": [
        {
          "id": "legal",
          "cost": "The front door: Authority 30, a clean record and a 2,000 cr records fee. The request is logged, and the Commissioner reads the log.",
          "outcome": { "setFlags": ["archive_legal", "hale_knows"], "credits": -2000, "comms": "m4.records.legal" }
        },
        {
          "id": "back",
          "cost": "The back way: run relay parts for the Mutual crew's maintenance slot. No clearance needed, but if the Commissioner finds out, that crew answers for it.",
          "outcome": { "setFlags": ["archive_back"], "standings": [{ "faction": "mutual", "delta": 10 }], "comms": "m4.relay_crew.back" }
        }
      ]
    },
    {
      "id": "deal",
      "afterStep": "hale",
      "choices": [
        {
          "id": "take",
          "cost": "Hale keeps the original. You keep a copy, which won't carry a hearing on its own. The Holdfast claims go in the registry.",
          "outcome": {
            "items": [{ "id": "settlement_50a", "state": "withheld", "where": "hale" }],
            "setFlags": ["hale_deal"],
            "commands": [{ "type": "registerHoldfastClaims", "registered": true }],
            "comms": "m4.hale.taken"
          }
        },
        {
          "id": "refuse",
          "cost": "You keep the file. The Holdfast claims stay in the pending box, and the Commissioner remembers your registry.",
          "outcome": {
            "setFlags": ["hale_refused", "settlement_file"],
            "commands": [{ "type": "setWorldFlag", "key": "settlement_registry", "value": "withdrawn" }],
            "comms": "m4.hale.refused"
          }
        }
      ]
    }
  ],
  "trace": "settlement-registry-entry"
}
